module.exports = __webpack_public_path__ + "img/arrow-dropdown.c34539e8.svg";